// extracted by mini-css-extract-plugin
export default {"result_table":"ResultModule_result_table__sQgCd","table_row":"ResultModule_table_row__Ej0QA","table_row_wrapper":"ResultModule_table_row_wrapper__Hrb8r"};